export const NotFoundPage = () => {
    return <>
        <div>NotFoundPage</div>
        <div>No tiene permisos para acceder a esta acción.</div>
    </>;
}
